import { ReactComponent as LogoSvg } from "@/assets/svg/logo.svg";
import { FaXTwitter, FaLinkedin } from "react-icons/fa6";
import { Link as NavLink } from "react-router-dom";
import { Link } from "./Buttons";

export const Footer = () => {
  return (
    <div className="footer pt-16">
      <div className="container mx-auto">
        <div className="flex flex-col gap-8">
          <Link className="mx-auto" to="/">
            <LogoSvg className="w-20 h-auto" />
          </Link>

          <div className="xl:w-1/2 mr-auto text-xl md:text-2xl text-white opacity-75">
            Build the Startup of Your Dreams on
            <br />
            the Cap Table You Can Trust
          </div>

          <div className="flex md:flex-row items-center justify-between">
            <div className="-mx-2.5 flex flex-col md:flex-row gap-4">
              {[
                { to: "/sign-in", text: "Login" },
                { to: "/sign-up", text: "Signup" },
                { to: "/faqs", text: "FAQs" },
                { to: "/pricing", text: "Pricing" },
                { to: "/contact-us", text: "Contact Us" },
              ].map(({ to, text }, tIdx) => (
                <Link className="px-2.5" to={to} key={tIdx}>
                  {text}
                </Link>
              ))}
            </div>

            <div className="-mx-2.5 flex gap-4">
              <Link className="px-2.5" to="https://twitter.com/T12_ai">
                <FaXTwitter color="white" size={32} />
              </Link>

              <Link
                className="px-2.5"
                to="https://www.linkedin.com/company/33313224/admin/feed/posts/"
              >
                <FaLinkedin color="white" size={32} />
              </Link>
            </div>
          </div>

          <Link className="!p-0" to="/sign-up">
            <div className="get-started">
              <span className="text-3xl md:text-4.5xl text-secondary font-bold">
                Get Started
              </span>

              <img src="/images/to-corner.png" alt="Get Started" />
            </div>
          </Link>
        </div>
      </div>

      <div className="border-t border-[#fff3]">
        <div className="container mx-auto py-5">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="text-[#ffffff80] font-clashGrotesk">
              © {new Date().getFullYear()} T12 Inc. All Rights Reserved.
            </div>

            <div className="flex items-center gap-4 justify-between">
              <NavLink
                className="text-[#ffffff80] font-clashGrotesk text-lg"
                to="legal/terms"
              >
                Terms of Use
              </NavLink>

              <NavLink
                className="text-[#ffffff80] font-clashGrotesk text-lg"
                to="/legal/privacy-policy"
              >
                Privacy Policy
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
